import {
  Container,
  Spacer,
  SvgChevronUp,
  Text,
  TextButton,
} from '@loomhq/lens';
import React from 'react';
import { useDispatch } from 'react-redux';
import { CSSTransitionGroup } from 'react-transition-group';

import { SHOW_GET_STARTED_CHECKLIST } from 'constants/triggers';
import { completeTriggerCreator } from 'creators/triggers';

import { useGetChecklistCompletionPercentage } from 'hooks/getStartedChecklist';

import GetStartedProgressBar from './ProgressBar';

import styles from './MiniChecklist.module.less';

const Icon = <SvgChevronUp />;

const Footer = ({ tasks }) => {
  const percentage = useGetChecklistCompletionPercentage();
  const dispatch = useDispatch();

  const nextTask = tasks.find(task => !task.isComplete);

  if (!nextTask) {
    return (
      <>
        100% -{' '}
        <TextButton
          size="small"
          onClick={() => {
            dispatch(completeTriggerCreator(SHOW_GET_STARTED_CHECKLIST));
          }}
        >
          Dismiss Checklist
        </TextButton>
      </>
    );
  }

  return (
    <Text size="small">
      {percentage}% - Next, {nextTask.title.toLowerCase()}
    </Text>
  );
};

const transitionClasses = {
  enter: styles.transitionEnter,
  enterActive: styles.transitionEnterActive,
  leave: styles.transitionLeave,
  leaveActive: styles.transitionLeaveActive,
};

export default function MiniChecklist({
  animatedTaskId,
  openChecklist,
  tasks,
  isCompact,
}) {
  const animatedTask = tasks.find(task => task.id === animatedTaskId);

  return (
    <Container
      padding="medium"
      backgroundColor="upgrade"
      borderSide="all"
      borderColor="#8accff20"
      radius="medium"
    >
      <div className={styles.titleBox}>
        <CSSTransitionGroup
          transitionName={transitionClasses}
          transitionEnterTimeout={300}
          transitionLeaveTimeout={300}
        >
          {!animatedTask && (
            <div className={styles.headerButton}>
              <TextButton
                icon={Icon}
                key="normal-heading"
                onClick={() => openChecklist?.()}
                iconPosition="right"
              >
                Get started with Loom
              </TextButton>
            </div>
          )}
          {animatedTask && (
            <Spacer top={0.625} key="animated-heading" bottom={0.625}>
              <Text fontWeight="medium">
                {animatedTask.completionIcon} {animatedTask.completionMessage}
              </Text>
            </Spacer>
          )}
        </CSSTransitionGroup>
      </div>
      {!isCompact && (
        <>
          <Spacer top="small">
            <GetStartedProgressBar tasks={tasks} />
          </Spacer>
          <p className={styles.message}>
            <Footer tasks={tasks} />
          </p>
        </>
      )}
    </Container>
  );
}
